exports = module.exports = require("../../../../../../legacy/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mx-datepicker-popup {\n  z-index: 1060;\n}\n.mx-datepicker {\n  width: 100% !important;\n}", ""]);

// exports
